import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import es from "vuetify/src/locale/es.ts";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },

    themes: {
      light: {
        primary: "#1565C0",
        secondary: colors.grey.lighten1,
        //secondary: '#424242',
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
  
    },
  },

  icons: {
    iconfont: "fa" || 'mdi',
  },

  lang: {
    locales: { es },
    current: "es",
  },
});
